// @flow

import { clamp } from 'lodash';

import { scaleBetween, percentageBetween } from './mathUtils';

export default function getGlobalLeaderboardScale(input: number, low: number, high: number) {
  return scaleBetween(clamp(percentageBetween(input, low, high), 0, 1), 0.3, 1);
}
